export default __webpack_public_path__ + "static/media/mo.7f4010dd.jpg";